import routes from "@/apps/dashboard/catalog/routing/routes";
import { routes as dashboardRoutes } from "@/routing/routes";
import ExportLayout from "@/apps/dashboard/catalog/view/pages/Export/ExportPage.vue";
import identificationService from "@/core/services/identification.service";
import ImportsListPage from "@/apps/dashboard/catalog/view/pages/Import/ImportsPage.vue";
import * as userConstants from "@/core/models/usersAndPermissions";

export default [
  {
    path: routes.catalogExport.path,
    name: routes.catalogExport.name,
    component: ExportLayout,
    beforeEnter: () => {
      if (
        !identificationService.hasPermission(userConstants.ROLE_EXPORT_PRODUCTS) ||
        !identificationService.hasPermission(userConstants.ROLE_EXPORT_CATEGORIES)
      ) {
        return { name: dashboardRoutes.home.name };
      }
    },
  },
  {
    path: routes.catalogImportsList.path,
    name: routes.catalogImportsList.name,
    component: ImportsListPage,
    meta: {
      permission: userConstants.ROLE_IMPORTS_PAGE,
    },
  },
];
